import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ToastProvider } from 'react-toast-notifications';
import storeFactory from './store';
import App from './App';
import i18n from './i18n';
import * as serviceWorker from './serviceWorker';
import './index.css';

const store = storeFactory();

window.React = React;
window.store = store;

// Prevent screen movements
//
// screenMovePreventer.prevent();

ReactDOM.render(
  <Provider store={store} >
    <Suspense fallback="Loading...">
      <I18nextProvider i18n={i18n}>
        <ToastProvider
          autoDismiss
          autoDismissTimeout={3500}
        >
          <App store={store} />
        </ToastProvider>
      </I18nextProvider>
    </Suspense>
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
